import * as e from "react";
import c from "../lib/IconBase.es.js";
import t from "../defs/CircleHalf.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(c, { ref: a, ...r, weights: t }));
o.displayName = "CircleHalfIcon";
const l = o;
export {
  l as CircleHalf,
  o as CircleHalfIcon
};
